var _path;
import { jsx as _jsx } from "react/jsx-runtime";
var Crown = function Crown(_ref) {
  var _ref$className = _ref.className,
    className = _ref$className === void 0 ? 'tw-text-neutral-light-800' : _ref$className,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 32 : _ref$size;
  return /*#__PURE__*/_jsx("svg", {
    className: className,
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    children: _path || (_path = /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M12 5a1 1 0 0 1 .832.445l3.395 5.093 4.148-3.319a1 1 0 0 1 1.606.977l-2 10A1 1 0 0 1 19 19H5a1 1 0 0 1-.98-.804l-2-10a1 1 0 0 1 1.605-.977l4.148 3.319 3.395-5.093A1 1 0 0 1 12 5Zm0 2.803-3.168 4.752a1 1 0 0 1-1.457.226L4.52 10.496 5.819 17H18.18l1.301-6.504-2.856 2.285a1 1 0 0 1-1.457-.226L12 7.803Z",
      fill: "none",
      className: "tw-fill-current"
    }))
  });
};
export default Crown;